module.exports = __webpack_public_path__ + "img/phone.5036d3a2.png";